import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";
import { join } from "../../Utils/utils";
import { DataS } from "../../Service/DataS";

const LetterHead = ({ inline, isCustomer, withPartner, documentType }) => {
  const { documentLayout, contact, customerContact, profile, loading } =
    useContext(ResourceContext);

  const partner = customerContact ? customerContact.partner : undefined;

  if (loading) {
    return <LoadingAnimation />;
  }
  const _contact = isCustomer ? customerContact : contact;
  const isPropDefined = (prop) => prop && prop !== "";

  const styles = {
    listStyle: {
      display: inline ? "inline-flex" : "block",
      listStyleType: inline ? "none" : "none",
      marginBottom: 0,
      paddingLeft: 0,
      flexWrap: "wrap",
      justifyContent: "center",
      width: '100%',
    },
    itemStyle: {
      marginRight: inline ? 20 : "unset",
      fontSize: 12,
    },
  };
  const {
    firstName,
    lastName,
    companyName,
    addressSupplement,
    addressStreetAndNo,
    zipCode,
    city,
    country,
    billingEmail,
    billingCompanyName,
    billingAddressStreetAndNo,
    billingZipCode,
    billingCity,
  } = _contact;
  const useBillingDetails =
    isCustomer &&
    (documentType === "INVOICE" || documentType === "PARTIAL_INVOICE");
  const displayedCompanyName =
    useBillingDetails && isPropDefined(billingCompanyName?.trim())
      ? billingCompanyName
      : companyName;
  const useBillingAddress =
    useBillingDetails &&
    isPropDefined(billingAddressStreetAndNo?.trim()) &&
    isPropDefined(billingZipCode?.trim()) &&
    isPropDefined(billingCity?.trim());
  const displayedAddressStreetAndNo = useBillingAddress
    ? billingAddressStreetAndNo
    : addressStreetAndNo;
  const displayedZipCode = useBillingAddress ? billingZipCode : zipCode;
  const displayedCity = useBillingAddress ? billingCity : city;
  const displayedBillingEmail =
    useBillingDetails && isPropDefined(billingEmail?.trim()) ? billingEmail : null;
  const { alias } = profile;
  const {
    contactName,
    showFounderPersonalName,
    showCompanyNameExclusively,
  } = documentLayout;
  const displayedContactName = isCustomer
    ? displayedCompanyName
    : contactName === "NONE"
    ? ""
    : contactName === "COMPANY"
    ? companyName
    : alias;
  const hideCustomerPersonalName =
    isCustomer &&
    showCompanyNameExclusively &&
    isPropDefined(displayedCompanyName?.trim());

  const partnerDefined = partner &&
      isPropDefined(partner.firstName) &&
      isPropDefined(partner.lastName);

  const sameLastname = partnerDefined &&
      isPropDefined(lastName) &&
      partner.lastName.trim() === lastName.trim();

  return (
    <ul style={styles.listStyle}>
      {isPropDefined(displayedContactName) ? (
        <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
          {displayedContactName}
        </li>
      ) : (
        <br />
      )}
      {(isPropDefined(firstName) || isPropDefined(lastName)) &&
        (showFounderPersonalName || isCustomer) &&
        !hideCustomerPersonalName && (
          <li style={styles.itemStyle}>
            {join([((withPartner && sameLastname) ? `${join([firstName, partner.firstName], " & ")}` : firstName), lastName], "")}
            {withPartner && !sameLastname && partnerDefined &&
              (isPropDefined(partner.firstName) ||
                isPropDefined(partner.lastName)) &&
              ` & ${join([partner.firstName, partner.lastName], "")}`}
          </li>
        )}
      {isPropDefined(addressSupplement) && (
        <li style={styles.itemStyle}>{addressSupplement}</li>
      )}
      {isPropDefined(displayedAddressStreetAndNo) && (
        <li style={styles.itemStyle}>
          {join([displayedAddressStreetAndNo], ",")}
        </li>
      )}
      {(isPropDefined(displayedZipCode) || isPropDefined(displayedCity)) && (
        <li style={styles.itemStyle}>
          {join([displayedZipCode, displayedCity], "")}
          <br />
        </li>
      )}
      {isCustomer && country && (
       <li style={styles.itemStyle}>
          {DataS.countryOptions.find((c) => c.value === country)?.label}
        </li>
      )}
      {displayedBillingEmail && (
        <li style={styles.itemStyle}>{displayedBillingEmail}</li>
      )}
    </ul>
  );
};

export default LetterHead;
